import type { PurchaseOrderStatus } from "@/server/platform/db/schema/purchase-orders";

export const PO_MENU_TITLE = "ໃບສັ່ງຊື້ (PO)";
export const SUPPLIER_MENU_TITLE = "ຜູ້ສະໜອງ";

export const PO_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  DRAFT: "ຮ່າງ",
  SUBMITTED: "ລໍຖ້າອະນຸມັດ",
  APPROVED: "ອະນຸມັດແລ້ວ",
  PARTIALLY_RECEIVED: "ຮັບບາງສ່ວນ",
  RECEIVED: "ຮັບຄົບແລ້ວ",
  CLOSED: "ປິດງານ",
  CANCELLED: "ຍົກເລີກ",
};

export const PO_SUGGESTION_REASON_LABELS = {
  LOW_STOCK: "ຕ່ຳກວ່າຂັ້ນຕ່ຳ (min)",
  BELOW_TARGET: "ຕ່ຳກວ່າເປົ້າເຕີມ (target)",
} as const;

export function poItemTypeLabel(
  itemType: "INGREDIENT" | "RETAIL_VARIANT",
): string {
  return itemType === "INGREDIENT" ? "ວັດຖຸດິບ" : "ຕົວແບບສິນຄ້າ";
}

export { formatLakDisplay as formatLakAmount } from "@/shared/lib/format-number";
